import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles({
  container:{
    marginTop:15,
    width:'100%'
  },
  table: {
    width:'100%'
  },
  title:{
    margin:20
  }
});

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];



export default function BasicTable({

marks_obtained_in_physics,
marks_obtained_in_chemistry,
  marks_obtained_in_maths,
marks_obtained_in_biology,
marks_obtained_in_mental_ability,
classs,
maximum_marks,
percentage,
total_marks_obtained,
total_highest,
total_avg,
sql_test_date,

physics_max,
chemistry_max,
maths_max,
mental_ability_max,
biology_max,
is_show_bio_ma,
physics_highest,
physics_avg,
physics_percentage,
chemistry_highest,
chemistry_percentage,
chemistry_avg,
maths_highest,
maths_percentage,
maths_avg,
biology_highest,
biology_percentage,
biology_avg,
mental_ability_highest,
mental_ability_avg,
mental_ability_percentage,
}) {
  const classes = useStyles();

  return (
    <>

    <TableContainer component={Paper}  style={{marginTop:15}}>
    <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
         Score Card
       </Typography>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell> </TableCell>

            <TableCell >Physics</TableCell>
            <TableCell >Chemistry</TableCell>
            <TableCell >Mathematics</TableCell>
            {is_show_bio_ma && <TableCell >Biology</TableCell>}
            {is_show_bio_ma &&  <TableCell >Mental Ability</TableCell>}
            <TableCell >Total</TableCell>
          </TableRow>
        </TableHead>

         <TableBody>


<TableRow  >
  <TableCell component="th" scope="row">
  Maximum Marks
  </TableCell>
  <TableCell >{physics_max}</TableCell>
<TableCell >{chemistry_max}</TableCell>
<TableCell >{maths_max}</TableCell>
{is_show_bio_ma &&  <TableCell >{biology_max}</TableCell>}
{is_show_bio_ma &&  <TableCell >{ mental_ability_max}</TableCell>}
<TableCell>{maximum_marks}</TableCell>


</TableRow>
            <TableRow  >
              <TableCell component="th" scope="row">
              Your Score
              </TableCell>
              <TableCell >{marks_obtained_in_physics}</TableCell>
              <TableCell >{marks_obtained_in_chemistry}</TableCell>
              <TableCell >{marks_obtained_in_maths}</TableCell>
              {is_show_bio_ma && <TableCell >{marks_obtained_in_biology}</TableCell>}
              {is_show_bio_ma && <TableCell >{marks_obtained_in_mental_ability}</TableCell>}
              <TableCell>{total_marks_obtained}</TableCell>

            </TableRow>

            <TableRow  >
              <TableCell component="th" scope="row">
              Your Percentage
              </TableCell>
              <TableCell >{ physics_percentage}</TableCell>
              <TableCell >{ chemistry_percentage}</TableCell>
              <TableCell >{ maths_percentage}</TableCell>
               {is_show_bio_ma && <TableCell >{ biology_percentage}</TableCell>}
              {is_show_bio_ma && <TableCell >{ mental_ability_percentage}</TableCell>}
              <TableCell>{percentage}</TableCell>

            </TableRow>

            <TableRow  >
              <TableCell component="th" scope="row">
              Highest Score
              </TableCell>
              <TableCell >{physics_highest }</TableCell>
              <TableCell >{chemistry_highest }</TableCell>
              <TableCell >{ maths_highest}</TableCell>
              {is_show_bio_ma && <TableCell >{biology_highest }</TableCell>}
              {is_show_bio_ma && <TableCell >{mental_ability_highest }</TableCell>}
              <TableCell >{total_highest }</TableCell>

            </TableRow>

            <TableRow  >
              <TableCell component="th" scope="row">
              Average Score
              </TableCell>
              <TableCell >{physics_avg }</TableCell>
              <TableCell >{ chemistry_avg}</TableCell>
               <TableCell >{ maths_avg}</TableCell>
              {is_show_bio_ma && <TableCell >{ biology_avg}</TableCell>}
              {is_show_bio_ma && <TableCell >{ mental_ability_avg}</TableCell>}
              <TableCell >{total_avg }</TableCell>

            </TableRow>




        </TableBody>

      </Table>
    </TableContainer>
    </>
  );
}
